export function Spinner({label = 'Loading'}: {label?: string}) {
  return (
    <span className="spinner-label" role="status">
      <span className="spinner" aria-hidden="true" />
      <span>{label}</span>
    </span>
  );
}

export function ListSkeleton({rows = 4, compact = false}: {rows?: number; compact?: boolean}) {
  return (
    <div className={`skeleton-list${compact ? ' compact' : ''}`} aria-label="Loading content" aria-busy="true">
      {Array.from({length: rows}, (_, index) => (
        <div className="skeleton-row" key={index}>
          <span className="skeleton-block short" />
          <span className="skeleton-block" />
          <span className="skeleton-block medium" />
        </div>
      ))}
    </div>
  );
}

export function MetricSkeleton({count = 4}: {count?: number}) {
  return (
    <section className="metric-grid skeleton-metrics" style={{gridTemplateColumns: `repeat(${count}, minmax(0, 1fr))`}} aria-label="Loading metrics" aria-busy="true">
      {Array.from({length: count}, (_, index) => (
        <article className="metric-card" key={index}>
          <span className="skeleton-block medium" />
          <span className="skeleton-block metric" />
        </article>
      ))}
    </section>
  );
}
